module.exports = __webpack_public_path__ + "img/bar.576d528.png";